@use "@design/design-tokens/border-radius/border-radius" as *;

.body {
  position: relative;
  width: 100%;
}

.fullscreenButtonContainer {
  display: flex;
  @include border-radius-r2;
  padding: 4px;
  background-color: var(--surface-default);
  height: 40px;
}

.styledChartAreaWrapper {
  min-height: 240px;

  [data-chart-body] {
    height: 240px;
  }
}

.container {
  position: relative;
  width: 100%;

  &.isChatMessage {
    .styledChartAreaWrapper {
      min-height: 476px;
    }

    [data-chart-body] {
      height: 476px;
    }
  }
}

.viewController {
  justify-content: space-between;
  padding: 10px 0;
}
